
import React from 'react';
import _ from 'lodash';

import InOutFieldAreasContext from './InOutFieldAreasContext';
import { InOutFieldAreasApi } from './InOutFieldAreasApi';
import InOutFieldAreasService from './InOutFieldAreasService';
import InOutDashboardApi from '../inOutDashboard/InOutDashboardApi'
import { FieldSettingsApi } from '../fieldSettings/FieldSettingsApi';
import FieldSettingsService from '../fieldSettings/FieldSettingsService';
import { FieldSettings } from '../../pages/FieldSettings';
import SessionStorageService from '../utilities/SessionStorageService';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  DIALOG_STATUS,
  FILE_CODE
} from '../../utilities/constants';
import PrintUtility from '../../utilities/printUtility';


export default class InOutFieldAreasStore extends React.Component {
  state = {
    isLoading: true, // API等でローディング中フラグ
    fieldId: SessionStorageService.getFieldId(), // 現場ID
    isShowNotExistFieldIdDialog: false, // 存在しない現場IDダイアログ
    areas: [], // エリアリスト
    deleteItem: {}, // 削除対象エリア
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示ステータス
    postalCode: null,
    showLocationInfoFlg: 0,
    informationModal: {
      title: null, // モーダルダイアログのタイトル
      message: null, // モーダルダイアログのメッセージ
      buttonText: null, // モーダルダイアログのボタンのタイトル
      multilineText: false, // モーダルダイアログメッセージには複数の行がある場合
    },
  }

  /**
   * 現場情報が存在しないエラーダイアログを閉じる
   * */
  closeNotExistFieldIdDialog = () => {
    this.setState({ isShowNotExistFieldIdDialog: false });
  };

  /**
   * エラーダイアログを閉じる
   */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = '';
    state.informationModal.buttonText = null;
    state.ccusConnectErrorMessage = null;
    this.setState(state);
  };

  /**
   * 削除対象エリアを選択
   * */
  selectDeleteArea = (area) => {
    if (area && area.hasOwnProperty('id')) {
      this.setState({ deleteItem: area });
    }
  }

  /**
   * 削除対象エリアをクリア
   * */
  clearDeleteArea = () => {
    this.setState({ deleteItem: {} });
  }

  /**
   * エリア位置情報利用フラグを切り替える
   * */
  toggleUseLocationInfoFlg = (id) => {
    this.setState(prevState => ({
      areas: _.map(prevState.areas, (area => 
        area.id === id 
          ? { ...area, use_location_info_flg: area.use_location_info_flg ? 0 : 1 } 
          : area
      ))
    }), () => {
      const area = _.find(this.state.areas, (area => area.id === id))
      InOutFieldAreasApi.editInOutFieldAreaLocationFlag(this.state.fieldId, area)
      .then(response => {
        if (!response.result) {            
          let _state = _.cloneDeep(this.state);          
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
          _state.areas = _.map(this.state.areas, (_area => 
            _area.id === id 
              ? { ..._area, use_location_info_flg: _area.use_location_info_flg ? 0 : 1 } 
              : _area
          ))
          this.setState(_state);
        }
      })
      .catch(error => {
        let _state = _.cloneDeep(this.state);
        _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
        _state.areas = _.map(this.state.areas, (_area => 
          _area.id === id 
            ? { ..._area, use_location_info_flg: _area.use_location_info_flg ? 0 : 1 } 
            : _area
        ))
        this.setState(_state);
      })
    });
  };

  /**
   * エリアリストを取得する
   * */
  fetchInOutFieldAreas = () => {
    let state = _.cloneDeep(this.state);
   
    return InOutFieldAreasApi.fetchInOutFieldAreas(state.fieldId)
      .then(response => {
        if (response.result) {
          this.setState(prevState => ({
            ...prevState,
            areas: InOutFieldAreasService.parseFetchInOutFieldAreasResponseData(response.data)
          }));
        } else {  
          let _state = _.cloneDeep(this.state);          
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
          this.setState(_state);
        }
      })
  };

  /**
   * エリアを削除する
   * */
  deleteArea = () => {
    let state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    this.setState({ isLoading: true }, () => {
      InOutFieldAreasApi.deleteArea(
        state.fieldId,
        state.deleteItem.id
      )
        .then(response => {
          if (response.result) {
            this.setState({ isLoading: false }, () => {
              this.clearDeleteArea();
              this.fetchInOutFieldAreas();
            });
          } else {
            this.clearDeleteArea();
            let _state = _.cloneDeep(this.state);
            _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
            this.setState(_state);
          }
        })
        .catch(error => {
          this.clearDeleteArea();
          let _state = _.cloneDeep(this.state);
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
          this.setState(_state);
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    });
  }

  /**
   * QRダウンロード・表示する
   * */
  downloadAreaQR = (areaId) => {
    let state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    this.setState({ isLoading: true }, () => {
      const newTab = window.open('/LayoutPrintQR', '_blank');
      InOutFieldAreasApi.downloadQRCode(state.fieldId, areaId)
        .then(response => {
          if (response.result) {
            if (response.pdf_s3_url && response.pdf_s3_url.get_pdf_url) {
              newTab.location.href = response.pdf_s3_url.get_pdf_url;
            } else {
              newTab.close();
            }
            if (response.data) {
              const filename = `QR_${state.fieldId}_${areaId}.pdf`;
              const pdfBlob = PrintUtility.convertBase64ToBlob(response.data, 'application/pdf')
              PrintUtility.printBlob(pdfBlob, filename, FILE_CODE.PDF);
            }
          } else {
            let _state = _.cloneDeep(this.state);

            newTab.close();
            _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
            this.setState(_state);
          }
        })
        .catch(error => {
          let _state = _.cloneDeep(this.state);

          newTab.close();
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
          this.setState(_state);
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
      });
  };

  fetchPostalCode = () => {
    let state = _.cloneDeep(this.state);

    return InOutDashboardApi.fetchFieldInfo(state.fieldId)
      .then(response => {
        if (response.result) {
          this.setState(prevState => ({
            ...prevState,
            postalCode: response.data.entities.field.postal_code
          }));
        } else {            
          let _state = _.cloneDeep(this.state);          
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
          this.setState(_state);
        }
      })
  }

  componentDidMount() {
    let state = _.cloneDeep(this.state);

    if (isNullOrEmpty(state.fieldId)) {
      state.isShowNotExistFieldIdDialog = true;
      this.setState(state);
      return;
    }

    // アプリ利用フラグの確認のため、現場設定情報取得APIを呼び出す
    FieldSettingsApi.fetchCheckInOutSettings(state.fieldId)
      .then(response => {
        if (response.result) {
          const settings = FieldSettingsService.parseFetchCheckInOutSettingsResponseData(
            response.data
          );

          // アプリ利用フラグが未設定の場合、現場設定に戻る
          if(!settings.use_worker_entrance_app_flg) {
            InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
          }

          this.setState({ showLocationInfoFlg: settings.show_location_info_flg });

          InOutFieldAreasApi.fetchInOutFieldAreas(state.fieldId)
            .then(response => {
              if (response.result) {
                this.setState(prevState => ({
                  ...prevState,
                  areas: InOutFieldAreasService.parseFetchInOutFieldAreasResponseData(response.data)
                }));
              } else {  
                let _state = _.cloneDeep(this.state);          
                _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
                this.setState(_state);
              }
            }).catch(error => {
              let _state = _.cloneDeep(this.state);      
              _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
              this.setState(_state);
            })
            .finally(() => {
              this.setState({ isLoading: false });
            });
        } else {
          InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
        }
      })
      .catch(() => {
        InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
      })
  }

  render() {
    return (
      <InOutFieldAreasContext.Provider
        value={{
          ...this.state,
          selectDeleteArea: this.selectDeleteArea,
          clearDeleteArea: this.clearDeleteArea,
          deleteArea: this.deleteArea,
          downloadAreaQR: this.downloadAreaQR,
          closeNotExistFieldIdDialog: this.closeNotExistFieldIdDialog,
          closeDialog: this.closeDialog,
          toggleUseLocationInfoFlg: this.toggleUseLocationInfoFlg
        }}
      >
        {this.props.children}
      </InOutFieldAreasContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/InOutFieldAreas/InOutFieldAreasStore.js